<template>
  <li class="currency-selector" data-test="mobile-menu__currency-selector">
    <ul>
      <MobileMenuItem ref="menuItem" :item="config.item" :item-modifier="itemModifier" :panel="true">
        <template #panel>
          <ul class="currency-elements" data-test="currencies-list">
            <li
              v-for="(currency, index) in currencies"
              :key="index"
              class="currency"
              @click="handleChangeCurrency(currency.val, currency.text, $event)"
            >
              <a class="currency-link" href="#">{{ currency.text }}</a>
            </li>
          </ul>
        </template>
      </MobileMenuItem>
    </ul>
  </li>
</template>

<script>
import { changeCurrency } from '../../../../shared/currency_form/currency_form'
import MobileMenuItem from '../MobileMenuItem/MobileMenuItem'

const componentName = 'MobileCurrencySelector'

export default {
  name: componentName,
  components: {
    MobileMenuItem,
  },
  props: {
    config: Object,
  },
  data() {
    return {
      itemModifier: '',
      currencies: [],
      select: null,
    }
  },
  created() {
    this.itemModifier = window.ibh.currency.current

    if (window.ibh?.currency?.list) {
      window.ibh?.currency?.list.forEach(currency => {
        this.currencies.push({
          val: currency,
          text: currency,
        })
      })
    }
  },
  methods: {
    handleChangeCurrency(value, text, event) {
      event.preventDefault()
      changeCurrency(value)
      this.itemModifier = text
      this.$refs.menuItem.closePanel()
    },
  },
}
</script>
